import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ScholarshipModel extends Model {
  @attr declare amount: number;
  @attr declare fromDate: string;
  @attr declare isActive: boolean;
  @attr declare isDependent: boolean;
  @attr declare scholarshipAward: string;
  @attr declare scholarshipStatusType: string;
  @attr declare thruDate: string;

  [Type] = 'scholarship' as const;
}
